import { hydrateRoot } from 'react-dom/client';
import { IntlProvider } from 'dibs-react-intl';
import serverVars from 'server-vars';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { getEnvironment } from '../relayModernEnvironment';
import { ServerVarsContextProvider } from '../shared/ServerVarsContext';
import { PhotosSearchBrowseContainer } from '../interiorsPhotos/PhotosSearchBrowseContainer';

const locale = serverVars.get('locale');

initializeDBL().then(() => {
    const interiorPhotosDOMNode = document.getElementById('js-root');
    if (interiorPhotosDOMNode !== null) {
        hydrateRoot(
            interiorPhotosDOMNode,
            <IntlProvider locale={locale} disableTranslations>
                <ServerVarsContextProvider
                    isMobile={serverVars.get('settings.isMobile')}
                    isTablet={serverVars.get('settings.isTablet')}
                    isDesktop={serverVars.get('settings.isDesktop')}
                >
                    <PhotosSearchBrowseContainer
                        environment={getEnvironment(true)}
                        relayVariables={serverVars.get('photosRelayVariables')}
                    />
                </ServerVarsContextProvider>
            </IntlProvider>
        );
    }
});
